/*
 Author : Jerome Martin
 Plugin guardian sert a bloqué l'acces a du contenu

 Markup :
 <div class="quoti-liseuse js-gardian-content" data-guardian-content-id="123456" data-guardian-content-type="journalff" data-guardian-unauthorized-msg="Vous n'avez pas accès à cette édition." data-guardian-callback="">

 </div>

 Setup :

 $(function() {
 $("body").guardian();
 });
 */
;
(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "guardian",
        defaults = {
            gardianClass: '.js-gardian-content',
            errorMsg: "Vous n'avez pas accès à cette édition."
        };


        function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this.datas = null;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setVars();
            this.setDatas();
            this.getProtectedContent();
        },

        setVars: function () {
            this.url = $("meta[property='mpp:gb']").attr("content");
        },

        setDatas: function () {
            var that = this;
            var datas = [];
            var obj = {};

            $(that.element).find(that.settings.gardianClass).each(function(i){
                obj = {content:{}};
                obj.content.id = $(this).data("guardian-content-id");
                obj.content.type = $(this).data("guardian-content-type");

                if (typeof obj.content.id == 'undefined' || typeof obj.content.type == 'undefined') {
                    console.warn("balise "+that.settings.gardianClass);
                    console.warn(obj);
                } else {
                    datas.push(obj);
                }
            });
            that.datas = datas;
        },

        getProtectedContent:function(){
            var that = this;
            $.each(that.datas,function(i,element){
                if(that.checkMppBought()){
                    that.callGuardian(element);
                }
            });
        }, 


        checkMppBought: function(){
            if (typeof connection.datas != 'object' || connection.datas == null) {
                return false;
            }
            if (typeof connection.datas.mpp != 'object'){
                return false;
            }

            if (connection.datas.mpp.has_bought == 1 || connection.datas.magAbonne == 1) {
                return true;
            } else {
                return false;
            }
        },

        callGuardian : function(element) {
            var that = this;
            var gbel = $(that.element).find(that.settings.gardianClass+"[data-guardian-content-id='"+element.content.id+"'][data-guardian-content-type='"+element.content.type+"']");
            $.ajax({
                type: 'POST',
                url: this.url,
                dataType: 'json',
                data: {
                    type: element.content.type,
                    id : element.content.id,
                    method: "getContent"
                },
                success: function (data) {
                    gbel.trigger("gb-check",data);
                }
            });
        }
});

$.fn[pluginName] = function (options) {
    this.each(function () {
        if (!$.data(this, "plugin_" + pluginName)) {
            $.data(this, "plugin_" + pluginName, new Plugin(this, options));
        }
    });
    return this;
};

})(jQuery, window, document);